import { DefaultApiEndpointsInterface } from '../interfaces/default-api-endpoints.interface';

export const DEFAULT_API_ENDPOINTS: DefaultApiEndpointsInterface = {};
